import { Languages } from '@/common/utils/constants';
import { QUERY_KEYS } from '@/common/types/react-query-keys.interfaces';
import { getClubById } from '@/common/utils/getClubById';
import { useQuery } from '@tanstack/react-query';

interface UseClubDataConfig {
  studioId: string | null;
  lang: Languages;
}

export default function useClubData({ studioId, lang }: UseClubDataConfig) {
  const {
    data: clubData,
    isLoading,
    isError,
  } = useQuery({
    queryKey: [QUERY_KEYS.CLUB_BY_ID, studioId, lang],
    queryFn: () => getClubById({ clubId: Number(studioId), lang }),
    enabled: Boolean(studioId),
  });

  return { clubData, isLoading, isError };
}
